// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { CommentStreamCountDetailFragmentDoc } from '../comments/CommentCountBubble.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ToDosQueryVariables = Types.Exact<{
  filter: Types.ToDoFilter;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ToDosQuery = { __typename?: 'Query', toDos: Array<{ __typename?: 'ToDo', id: string, dueDate?: Types.Scalars['Date']['input'] | null | undefined, name: string, description?: string | null | undefined, order: string, urgent: boolean, status: { __typename?: 'ToDoStatusDetail', name: string, code: Types.ToDoStatus, sortOrder: number }, type: { __typename?: 'ToDoTypeDetail', name: string, code: Types.ToDoType }, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl: string, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }>, parent?:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Cohort', id: string, name: string }
      | { __typename?: 'Development', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
     | null | undefined, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number }>, followers: Array<{ __typename?: 'InternalUser', id: string, name: string }>, checklistProgress: { __typename?: 'ToDoChecklistProgress', total: number, completed: number } }> };

export type ToDoStatusesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ToDoStatusesQuery = { __typename?: 'Query', toDoStatuses: Array<{ __typename?: 'ToDoStatusDetail', code: Types.ToDoStatus, name: string, sortOrder: number }> };

export type ToDoTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ToDoTypesQuery = { __typename?: 'Query', toDoTypes?: Array<{ __typename?: 'ToDoTypeDetail', code: Types.ToDoType, name: string }> | null | undefined };

export type ToDoCardFragment = { __typename?: 'ToDo', id: string, dueDate?: Types.Scalars['Date']['input'] | null | undefined, name: string, description?: string | null | undefined, order: string, urgent: boolean, status: { __typename?: 'ToDoStatusDetail', name: string, code: Types.ToDoStatus, sortOrder: number }, type: { __typename?: 'ToDoTypeDetail', name: string, code: Types.ToDoType }, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl: string, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }>, parent?:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Cohort', id: string, name: string }
    | { __typename?: 'Development', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
   | null | undefined, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number }>, followers: Array<{ __typename?: 'InternalUser', id: string, name: string }>, checklistProgress: { __typename?: 'ToDoChecklistProgress', total: number, completed: number } };

export const ToDoCardFragmentDoc = gql`
    fragment ToDoCard on ToDo {
  id
  dueDate
  status {
    name
    code
    sortOrder
  }
  type {
    name
    code
  }
  name
  description
  assignees {
    id
    name
    avatarUrl
    internalUser {
      id
    }
  }
  parent {
    ... on Named {
      id
      name
    }
  }
  order
  streams {
    ...CommentStreamCountDetail
  }
  urgent
  followers {
    id
    name
  }
  checklistProgress {
    total
    completed
  }
}
    ${CommentStreamCountDetailFragmentDoc}`;
export const ToDosDocument = gql`
    query ToDos($filter: ToDoFilter!, $first: Int) {
  toDos(filter: $filter, first: $first) {
    ...ToDoCard
  }
}
    ${ToDoCardFragmentDoc}`;

/**
 * __useToDosQuery__
 *
 * To run a query within a React component, call `useToDosQuery` and pass it any options that fit your needs.
 * When your component renders, `useToDosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToDosQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useToDosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ToDosQuery, ToDosQueryVariables> & ({ variables: ToDosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ToDosQuery, ToDosQueryVariables>(ToDosDocument, options);
      }
export function useToDosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ToDosQuery, ToDosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ToDosQuery, ToDosQueryVariables>(ToDosDocument, options);
        }
// @ts-ignore
export function useToDosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ToDosQuery, ToDosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ToDosQuery, ToDosQueryVariables>;
export function useToDosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDosQuery, ToDosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ToDosQuery | undefined, ToDosQueryVariables>;
export function useToDosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDosQuery, ToDosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ToDosQuery, ToDosQueryVariables>(ToDosDocument, options);
        }
export type ToDosQueryHookResult = ReturnType<typeof useToDosQuery>;
export type ToDosLazyQueryHookResult = ReturnType<typeof useToDosLazyQuery>;
export type ToDosSuspenseQueryHookResult = ReturnType<typeof useToDosSuspenseQuery>;
export type ToDosQueryResult = ApolloReactCommon.QueryResult<ToDosQuery, ToDosQueryVariables>;
export const ToDoStatusesDocument = gql`
    query ToDoStatuses {
  toDoStatuses {
    code
    name
    sortOrder
  }
}
    `;

/**
 * __useToDoStatusesQuery__
 *
 * To run a query within a React component, call `useToDoStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useToDoStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToDoStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useToDoStatusesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ToDoStatusesQuery, ToDoStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ToDoStatusesQuery, ToDoStatusesQueryVariables>(ToDoStatusesDocument, options);
      }
export function useToDoStatusesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ToDoStatusesQuery, ToDoStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ToDoStatusesQuery, ToDoStatusesQueryVariables>(ToDoStatusesDocument, options);
        }
// @ts-ignore
export function useToDoStatusesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ToDoStatusesQuery, ToDoStatusesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ToDoStatusesQuery, ToDoStatusesQueryVariables>;
export function useToDoStatusesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDoStatusesQuery, ToDoStatusesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ToDoStatusesQuery | undefined, ToDoStatusesQueryVariables>;
export function useToDoStatusesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDoStatusesQuery, ToDoStatusesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ToDoStatusesQuery, ToDoStatusesQueryVariables>(ToDoStatusesDocument, options);
        }
export type ToDoStatusesQueryHookResult = ReturnType<typeof useToDoStatusesQuery>;
export type ToDoStatusesLazyQueryHookResult = ReturnType<typeof useToDoStatusesLazyQuery>;
export type ToDoStatusesSuspenseQueryHookResult = ReturnType<typeof useToDoStatusesSuspenseQuery>;
export type ToDoStatusesQueryResult = ApolloReactCommon.QueryResult<ToDoStatusesQuery, ToDoStatusesQueryVariables>;
export const ToDoTypesDocument = gql`
    query ToDoTypes {
  toDoTypes {
    code
    name
  }
}
    `;

/**
 * __useToDoTypesQuery__
 *
 * To run a query within a React component, call `useToDoTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useToDoTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToDoTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useToDoTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ToDoTypesQuery, ToDoTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ToDoTypesQuery, ToDoTypesQueryVariables>(ToDoTypesDocument, options);
      }
export function useToDoTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ToDoTypesQuery, ToDoTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ToDoTypesQuery, ToDoTypesQueryVariables>(ToDoTypesDocument, options);
        }
// @ts-ignore
export function useToDoTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ToDoTypesQuery, ToDoTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ToDoTypesQuery, ToDoTypesQueryVariables>;
export function useToDoTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDoTypesQuery, ToDoTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ToDoTypesQuery | undefined, ToDoTypesQueryVariables>;
export function useToDoTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDoTypesQuery, ToDoTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ToDoTypesQuery, ToDoTypesQueryVariables>(ToDoTypesDocument, options);
        }
export type ToDoTypesQueryHookResult = ReturnType<typeof useToDoTypesQuery>;
export type ToDoTypesLazyQueryHookResult = ReturnType<typeof useToDoTypesLazyQuery>;
export type ToDoTypesSuspenseQueryHookResult = ReturnType<typeof useToDoTypesSuspenseQuery>;
export type ToDoTypesQueryResult = ApolloReactCommon.QueryResult<ToDoTypesQuery, ToDoTypesQueryVariables>;